<template>
  <div class="game-tab-wrapper" :class="{ 'fixed': isFixedGameTab }">
    <div class="game-tab" :class="language" v-if="!loading">
      <div class="tab-btn hot-btn" @click="setTab('hot')" :class="{ 'active': currentGameTab === 'hot' }" :style="{ width: tabBtnWidth, 'justify-content': tabBtnJustifyContent }">
        <span>{{ $ln('熱門') }}</span>
      </div>
      <div class="tab-btn fish-btn" v-if="tabGameList.fish && tabGameList.fish.length !== 0" @click="setTab('fish')" :class="{ 'active': currentGameTab === 'fish' }" :style="{ width: tabBtnWidth, 'justify-content': tabBtnJustifyContent }">
        <span>{{ $ln('捕魚機') }}</span>
      </div>
      <div class="tab-btn slot-btn" v-if="tabGameList.slot && tabGameList.slot.length !== 0" @click="setTab('slot')" :class="{ 'active': currentGameTab === 'slot' }" :style="{ width: tabBtnWidth, 'justify-content': tabBtnJustifyContent }">
        <span>{{ $ln('老虎機') }}</span>
      </div>
      <div class="tab-btn arcade-btn" v-if="tabGameList.arcade && tabGameList.arcade.length !== 0" @click="setTab('arcade')" :class="{ 'active': currentGameTab === 'arcade' }" :style="{ width: tabBtnWidth, 'justify-content': tabBtnJustifyContent }">
        <span>{{ $ln('街機') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Base from '@/mixins/base'
import { mapState } from 'vuex'

export default {
  name: 'GameTab',
  props: {
    isFixedGameTab: {
      type: Boolean,
      default() {
        return false
      }
    },
    // 當前點擊遊戲分類
    currentGameTab: {
      type: String,
      default() {
        return 'hot'
      }
    },
    // 設定當前tab
    setTab: {
      type: Function,
      default() {
        return
      }
    },
    // 各分類遊戲清單
    tabGameList: {
      type: [Array, Object],
      default() {
        return []
      }
    },
    // 目前裝置
    isDevice: {
      type: String,
      default() {
        return ''
      }
    },
    // 遊戲清單載入狀態
    loading: {
      type: [String, Boolean],
      default() {
        return false
      }
    }
  },
  data() {
    return {
    }
  },
  mixins: [
    Base
  ],
  computed: {
    ...mapState({
      language: state => state.app.language,
    }),
    // 計算可顯示的遊戲分類按鈕數量
    visibleTabsCount() {
      let count = 1 // 「熱門」按鈕會一直顯示
      if (this.tabGameList.fish && this.tabGameList.fish.length > 0) count++
      if (this.tabGameList.slot && this.tabGameList.slot.length > 0) count++
      if (this.tabGameList.arcade && this.tabGameList.arcade.length > 0) count++
      return count
    },
    // 動態計算遊戲分類按鈕寬度
    tabBtnWidth() {
      const width = `${(100 / this.visibleTabsCount).toFixed(2)}%`
      console.log('遊戲分類按鈕數量：', this.visibleTabsCount, `(width: ${width})`)
      return width
    },
    // 動態設定遊戲分類按鈕 justify-content (只有電腦版才動態設定)
    tabBtnJustifyContent() {
      if (this.isDevice === 'desktop') return this.visibleTabsCount <= 3 ? 'center' : 'flex-start'
      return 'center'
    }
  },
  watch: {},
  components: {},
  created() {},
  async mounted() {},
  beforeDestroy() {},
  methods: {}
}
</script>
<style lang="scss" src="@/assets/css/app.scss"></style>
